import { Link } from "react-router-dom";
import { Star, ShieldCheck, BadgeCheck, Award, Umbrella, Check } from "lucide-react";

export function Logo({ light = false, className = "h-8" }) {
  return (
    <Link to="/" className="inline-flex items-center" data-testid="logo-link">
      <img src={light ? "/logo-white.png" : "/logo.png"} alt="book my carer" className={`${className} w-auto`} />
    </Link>
  );
}

const BADGE_META = {
  aadhaar: { label: "Aadhaar", icon: ShieldCheck, cls: "bg-sage-soft text-sage-deep" },
  police: { label: "Police checked", icon: BadgeCheck, cls: "bg-[#E7EDF5] text-[#3A5A86]" },
  cert: { label: "BMC Certified", icon: Award, cls: "bg-coral-soft text-coral-deep" },
  insured: { label: "Insured", icon: Umbrella, cls: "bg-butter-soft text-[#9A7320]" },
};

export function TrustBadge({ type }) {
  const m = BADGE_META[type];
  if (!m) return null;
  const Icon = m.icon;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-[3px] rounded-[7px] ${m.cls}`} data-testid={`badge-${type}`}>
      <Icon size={11} /> {m.label}
    </span>
  );
}

const PILL_META = {
  Active: "bg-sage-soft text-sage-deep", Verified: "bg-sage-soft text-sage-deep",
  Paid: "bg-sage-soft text-sage-deep", Completed: "bg-line-2 text-ink-soft", Settled: "bg-sage-soft text-sage-deep",
  Pending: "bg-butter-soft text-[#9A7320]", "In Progress": "bg-butter-soft text-[#9A7320]",
  "Pending Verification": "bg-butter-soft text-[#9A7320]", Unsettled: "bg-butter-soft text-[#9A7320]",
  Cancelled: "bg-coral-soft text-coral-deep", Failed: "bg-coral-soft text-coral-deep", Suspended: "bg-coral-soft text-coral-deep",
  Confirmed: "bg-sage-soft text-sage-deep", Requested: "bg-[#E7EDF5] text-[#3A5A86]", Upcoming: "bg-[#E7EDF5] text-[#3A5A86]",
  Inactive: "bg-line-2 text-ink-soft", Draft: "bg-line-2 text-ink-soft",
};

export function StatusPill({ status }) {
  return (
    <span className={`inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-full ${PILL_META[status] || "bg-line-2 text-ink-soft"}`} data-testid={`pill-${status}`}>
      {status}
    </span>
  );
}

export function Avatar({ initials, gradient, size = 56 }) {
  return (
    <span
      className="grid place-items-center rounded-full font-display font-bold text-white shrink-0"
      style={{ width: size, height: size, background: gradient || "linear-gradient(140deg,#EC5E3F,#F4C45D)", fontSize: size / 2.6 }}
    >
      {initials}
    </span>
  );
}

export function Stars({ rating, size = 14 }) {
  return (
    <span className="inline-flex items-center gap-1 text-butter">
      <Star size={size} fill="currentColor" strokeWidth={0} />
      <span className="text-ink font-semibold text-sm">{rating || "New"}</span>
    </span>
  );
}

export function VerifiedTick() {
  return (
    <span className="inline-grid place-items-center w-[18px] h-[18px] rounded-full bg-sage text-white" title="Verified">
      <Check size={12} strokeWidth={3} />
    </span>
  );
}

export function rupee(n) {
  return "₹" + Number(n).toLocaleString("en-IN");
}
